import { Identifiable, List } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeList(httpClient: HttpClient) {
  return ({ uuid }: Identifiable<List>) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/activities/${uuid}`,
      method: HttpMethods.DELETE,
    });
}

export { removeList };
